/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useCallback } from 'react'

interface CustomDOMRect {
  x: number
  y: number
  width: number
  height: number
  top: number
  left: number
  bottom: number
  right: number
}

const defaultRectState = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
}

export const useMeasure = (): [null | React.RefCallback<Element>, CustomDOMRect] => {
  const [rect = defaultRectState, setRect] = useState<CustomDOMRect>(defaultRectState)

  if (typeof window === 'undefined' || !('ResizeObserver' in window)) {
    return [null, rect]
  }

  const [observer] = useState(
    () =>
      new window.ResizeObserver(
        ([entry]) => setRect(entry.contentRect) as unknown as CustomDOMRect,
      ),
  )

  const ref = useCallback(
    (node: Element) => {
      observer.disconnect()
      if (node) {
        observer.observe(node)
      }
    },
    [observer],
  )

  return [ref, rect]
}
